module.exports = __webpack_public_path__ + "img/group25@2x-en.d80c5941.png";